/**
 * @Author: hangbale
 * @Date:   2017-08-03
 * @Email:  571312070@qq.com
 * @Last modified by:   hangbale
 * @Last modified time: 2017-08-08
 */

import http from 'axios';

export default {
    register (type, user) {
        var url = type === 'email' ? '/api/user/register/email' : '/api/user/register/phone';

        return http.post(url, user);
    }
}



// WEBPACK FOOTER //
// ./src/service/user.js